import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { CancelSubscriptionType, PackageThumbnail } from '../../common/services/package/package.model';
import { ChurnRetentionAction } from './churn-retention-dialog.action';
import { PaycellService } from '../services/paycell.service';
import { MasterpassService } from '../services/masterpass.service';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import UtilService from '../../common/services/util.service';
import { ApplyChurnSuccessResponse } from '../../common/services/package/package.model';
/* @ngInject */
export default class CancelSubscriptionDialogController implements ActionHandler {
  private dialogElement;

  protected packet: PackageThumbnail;
  protected onDeleteSuccess: (type: CancelSubscriptionType) => void;
  protected onChurnSuccess: (messageObj: ApplyChurnSuccessResponse) => void;
  private msisdnTr: string;
  private masterCardName: string;

  private discountedMonthStr: string;
  private discountedMonth: string;
  private normalPrice: string;
  private discountRate: string;
  private discountedPrice: string;

  constructor(
    private $element,
    private $sce,
    private $translate,
    private actionDispatcher: ActionDispatcherService,
    private googleAnalytics: GoogleAnalyticsService,
    private $timeout: ITimeoutService,
    private paycellService: PaycellService,
    private masterpassService: MasterpassService,
    private globalSpinner: GlobalSpinnerService
  ) {
    this.actionDispatcher.register(this);
  }
  public $postLink() {
    this.dialogElement = this.$element.find('#churn-retention-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof ChurnRetentionAction) {
        this.$translate('dialog.churnRetention.discountedMonth', {month: action.discountedRenewalCount}).then(value => {
            this.discountedMonthStr = value;
        });

        this.$translate('dialog.churnRetention.normalPrice', {price: action.price}).then(value => {
            this.normalPrice = value;
        });

        this.$translate('dialog.churnRetention.discountRate', {rate: action.discountRate}).then(value => {
            this.discountRate = value;
        });

        this.$translate('dialog.churnRetention.discountedPrice', {discountedPrice: action.discountedPrice}).then(value => {
            this.discountedPrice = value;
        });
      this.discountedMonth = action.discountedRenewalCount;
      this.packet = action.packet;
      this.onDeleteSuccess = action.onDeleteSuccess;
      this.onChurnSuccess = action.onChurnSuccess;
      this.msisdnTr = action.msisdnTr;
      this.masterCardName = action.masterCardName;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onChurnRetention() {
    this.close();
    this.globalSpinner.start();
    this.paycellService
      .retentionOfferAccept(this.packet.id)
      .then((response:boolean) => {
        this.globalSpinner.stop();
        if(response) {
            var successObj: ApplyChurnSuccessResponse = {} as ApplyChurnSuccessResponse;
            successObj.discountedMonth = this.discountedMonth;
            successObj.discountedPrice = this.discountedPrice;
           if(this.packet.nextRenewalDate){
                successObj.day = this.packet.nextRenewalDate.day;
                successObj.month = this.packet.nextRenewalDate.month;
                successObj.year = this.packet.nextRenewalDate.year;
                
            } 
            this.onChurnSuccess(successObj);
            
          //this.googleAnalytics.sendChurnPackage('Success',this.packet);
        } else{
            //TODO: Show error message
        }
      })
      .catch((error) => { 
        console.log('error', error); 
        //this.googleAnalytics.sendChurnPackage('Failure',this.packet, error);
        this.globalSpinner.stop();
    });
  }

  public onDelete() {
    if (this.masterCardName && this.msisdnTr) {
      this.masterpassService.recurringOrderDelete({
        accountChangedEventName: '',
        accountKey: this.msisdnTr,
        authenticationMethod: '',
        cardAlias: this.masterCardName,
        productId: this.packet.sardisOfferId,
        requestReferenceNumber: UtilService.generateRandomNumber(999999999999).toString()
      }).catch(() => null);
    }

    this.paycellService
      .deletePacket(this.packet)
      .then((response:CancelSubscriptionType) => {
        this.close();
        this.onDeleteSuccess(response);
      })
      .catch((error) => {
        console.log('error', error);
        this.googleAnalytics.sendCancelPackage('Failure',this.packet, error);
        this.close()});
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/churn-retention-dialog/churn-retention-dialog.controller.ts